import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js'
import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import React, { useState } from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import { Amex, Diners, Discover, Jcb, Mastercard, UnionPay, Visa } from 'assets/images'

const CheckoutForm = ({ onSubmit, closeAddCard, clientSecret, isLoading, isDirect = false ,isAdmin = false}) => {
  const stripe = useStripe()
  const elements = useElements()
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)

  const handleSubmit = async e => {

    e.preventDefault()


    if (!stripe || !elements || !clientSecret) return


    /* 2️⃣  confermo il SetupIntent */
    const cardElement = elements.getElement(CardElement);
    const { setupIntent, error } =
      await stripe.confirmCardSetup(clientSecret, {
      payment_method: {
        card: cardElement,

      },
    });

    if (error) {
      setLoading(false)
      alert(error.message)
      return
    }

    /* 3️⃣  se la carta NON richiede 3-D Secure */
    if (setupIntent.status === 'succeeded') {

      onSubmit()


    }

  }

  return (
    <form>

      {!isAdmin && (
        <>
          <p className="text-3xl text-black font-semibold">{t('Pay.Title')}</p>
          <p className="text-base text-[#828282] font-normal">{t('Pay.Subtitle')}</p>
        </>
      )}



      <div className="mt-[20px]">

        <div className="flex gap-2 items-center">
          <p className="text-sm font-normal text-[#595961]">{t('Pay.AcceptedCards')}</p>

          <img src={Amex} style={{ width: '32px' }} alt="amex" />
          <img src={Visa} style={{ width: '32px' }} alt="visa" />
          <img src={Discover} style={{ width: '32px' }} alt="discover" />
          <img src={Mastercard} style={{ width: '32px' }} alt="" />
          <img src={Jcb} style={{ width: '32px' }} alt="" />
          <img src={Diners} style={{ width: '32px' }} alt="" />
          <img src={UnionPay} style={{ width: '32px' }} alt="" />

        </div>

        <div className="mt-[40px]">

          <CardElement
            className="stripe-input"
            options={{
              style: {
                base: {
                  fontSize: '16px',
                  color: '#000',
                  fontFamily: 'Inter, sans-serif',
                  '::placeholder': {
                    color: '#d9d9d9'
                  }
                },
                invalid: {
                  color: '#fa755a',
                  iconColor: '#fa755a'
                }
              }

            }} />
        </div>


      </div>


      <div className={`flex gap-2 pt-10 justify-end`}>
        {/* Pulsanti */}
        <div className="mt-[58px] flex justify-center">

          {(isDirect || isAdmin) && (<Button
            onClick={() => {
              closeAddCard()
            }}
            type="button"
            variant="outlined"
            sx={{
              width: 124,
              borderColor: '#919191',
              fontSize: '16px',
              textTransform: 'none',
              color: '#919191',
              paddingLeft: '22px',
              paddingRight: '22px',
              fontWeight: 600,
              marginRight: 2
            }}
          >
            {t('Signup.Back')}
          </Button>)}

          <Button
            onClick={(e)=>{
              handleSubmit(e)
            }}
            variant="contained"
            disabled={loading || isLoading}
            sx={{
              width: loading || isLoading ? 148 : 124,
              paddingLeft: '22px',
              paddingRight: '22px',
              fontWeight: 600,
              backgroundColor: '#0049EE',
              fontSize: '16px',
              textTransform: 'none'
            }}
          >
            {t('Otp.Buy')}

            {loading || isLoading && (<CircularProgress size="20px" style={{ marginLeft: 8, color: 'white' }} />)}

          </Button>

        </div>
      </div>


    </form>
  )
}
export default CheckoutForm



